const dowNames = [
  "Niedziela",
  "Poniedziałek",
  "Wtorek",
  "Środa",
  "Czwartek",
  "Piątek",
  "Sobota",
]
const dowNamesShort = ["Nie", "Pon", "Wto", "Śro", "Czw", "Pia", "Sob"]

export class DowUtils {
  static getDowName(i) {
    return dowNames[i]
  }
  static getShortDowName(i) {
    return dowNamesShort[i]
  }
}
